const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "")
).replace(/\/$/, "");

console.log(
  "[API Config] REACT_APP_API_BASE_URL:",
  process.env.REACT_APP_API_BASE_URL,
);
console.log("[API Config] Final API_BASE_URL:", API_BASE_URL);

export default API_BASE_URL;
